import useAtomAssistEventHandlers from "src/views/assistant/hooks/useAtomAssistEventHandlers";
import { useCallback } from "react";
import { StreamingState } from "src/reusable/Chat/ChatStreaming/stores/StreamingStore";
import { useFfnStore } from "../store/FfnStore";

/** Atom Assist's stream handlers plus dialogue-id syncing into the 50.59 store. */
const useFfnEventHandlers = () => {
  const { metadataHandler: atomAssistMetadataHandler, messageHandler } =
    useAtomAssistEventHandlers();

  const setDialogueId = useFfnStore((state) => state.setDialogueId);

  const metadataHandler = useCallback(
    (metadata: any, streamingState: StreamingState) => {
      if (metadata?.dialogue_id) {
        setDialogueId(metadata.dialogue_id);
      }
      atomAssistMetadataHandler(metadata, streamingState);
    },
    [setDialogueId, atomAssistMetadataHandler],
  );

  return { metadataHandler, messageHandler };
};

export default useFfnEventHandlers;
